import module from 'fan/proyecto/module.js'
import template from './template.html'


export class fanProyectoColaboradoresEditarBajasListaComponent {
  constructor ($filter) {
    this.filterBy = $filter('filter')
    this.idProyecto = null
    this.data = null
    this.onChange = null
    this.filtro = ''
  }

  $onChanges (changes) {
    if (changes.data) {
      this.filtrar()
    }
  }
  $onInit () {
    this.filtrar()
  }

  filtrar () {
    this.resultados = this.filterBy(this.data, this.filtro)
  }
}
module.component('fanProyectoColaboradoresEditarBajasLista', {
  controller: fanProyectoColaboradoresEditarBajasListaComponent,
  template,
  bindings: {
    data: '<',
  },
})





// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/bajas/lista/component.js